<template>
  <div class="pt-2">
    <v-alert v-if="error" type="error"> {{ error }} </v-alert>
    <v-alert
      v-else-if="!queueState"
      type="info"
      :loading="loading"
      class="mb-0"
    >
      Carregando informações da fila...
    </v-alert>
    <v-alert
      v-else-if="status === 'pre_queue'"
      class="mb-0"
      type="info"
      :loading="loading"
    >
      <div class="d-flex justify-space-between">
        <h6 class="mb-0">Esse evento não está usando fila de acesso</h6>
        <v-btn @click="getQueueState" small icon :loading="loading">
          <v-icon small>mdi-refresh</v-icon>
        </v-btn>
      </div>
      <p>
        A fila será ativada automaticamente quando o evento atingir mais
        {{ queueState?.settings?.maxAccessSize }} acessos em
        {{ Math.ceil(queueState?.settings?.accessDuration / 60) }} minuto
      </p>
      <v-progress-linear
        :value="
          (queueState?.accessSize / queueState?.settings?.maxAccessSize) * 100
        "
        rounded
        height="20"
      ></v-progress-linear>
    </v-alert>
    <template v-else>
      <v-alert v-if="status === 'queue'" type="warning">
        <div class="d-flex justify-space-between">
          <h6 class="mb-0">Esse evento está com muitos acessos</h6>
          <v-btn @click="getQueueState" small icon :loading="loading">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </div>
        <p>Os acessos estão sendo processados na ordem de chegada</p>
        <v-progress-linear
          :value="(processingSize / (processingSize + waitingSize)) * 100"
          rounded
          color="white"
          height="20"
        >
          {{ processingSize }} / {{ processingSize + waitingSize }}
        </v-progress-linear>
      </v-alert>
      <v-card outlined class="pa-3">
        <h6>
          Fila
          <v-chip x-small color="info" class="mx-1">
            Processando: {{ processingSize }}
          </v-chip>
          <v-chip x-small color="warning">
            Aguardando: {{ waitingSize }}
          </v-chip>
        </h6>
        <div style="overflow-x: auto" class="d-flex gap-2 py-3">
          <v-chip
            v-for="(initialPosition, id) in queueState?.processing"
            :key="id"
            small
            label
            color="info"
            class="flex-shrink-0"
          >
            #{{ id | shortId }}
          </v-chip>
          <v-chip
            v-for="(id, i) in queueState?.waiting"
            :key="id"
            small
            label
            color="warning"
            class="flex-shrink-0"
          >
            <b>{{ i + 1 }}.</b> #{{ id | shortId }}
          </v-chip>
        </div>
      </v-card>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PARTY from "@/services/admin/party";

export default {
  data: () => ({
    loading: false,
    error: null,
    queueState: null,
    timeout: null,
  }),
  methods: {
    async getQueueState() {
      try {
        clearTimeout(this.timeout);
        this.loading = true;
        const { state } = await PARTY.queue.getState(
          this.party.organizationId,
          this.party.id
        );
        this.queueState = state;
        this.timeout = setTimeout(() => this.getQueueState(), 5000);
      } catch (e) {
        this.error = e?.message || "Erro ao buscar estado da fila";
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("organization", ["selectedOrganization"]),
    status() {
      if (!this.queueState) return null;
      if (this.queueState.waiting.length > 0) return "queue";
      return "pre_queue";
    },
    processingSize() {
      return Object.keys(this.queueState?.processing || {}).length;
    },
    waitingSize() {
      return this.queueState?.waiting.length;
    },
  },
  mounted() {
    this.getQueueState();
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style></style>
